<template>
	<div class="ordermanagement-wrap">
		<cIndex  ref="header"></cIndex>
		<div class="ordermanagement">
			<div class="ordermanagement-null" v-show="isShowNull">
					<img src="../assets/Group.png" alt="">
					<p>暂无订单</p>
			</div>
			<div class="ordermanagement-list" v-show="isShowOrderList">
				<div style="height:.3rem;"></div>
				<div class="list-content" v-for="(item ,index) in getOrserList">
					<div class="div">
						<h4><b>套餐类型 : </b><span>{{item.tc}}</span></h4>
						<div>
							<em v-if = "item.orderstatus == 1"><b>订单状态 ：</b>待付款</em>
							<em v-if = "item.orderstatus == 2"><b>订单状态 ：</b>已支付</em>
							<em v-if = "item.orderstatus == 3"><b>订单状态 ：</b>已取消</em>
							<em v-if = "item.orderstatus == 4"><b>订单状态 ：</b>已删除</em>
							<p @click="buttonCancel(item.tc)"  class="button-cancel" v-if="item.orderstatus =='3' && item.cpstatus == '0' ">再次购买</p>
							<p @click="buttonOrder(item.ordernumber,item.id)" class="button-noOrder" v-if="item.orderstatus =='1' && item.cpstatus == '0' ">立即支付</p>
							<p @click="buttonLook(item.id,item.pid,item.bid)" class="button-order" v-if="(item.orderstatus =='2' || item.orderstatus =='3')&&item.cpstatus >'0' ">查看报告</p>
							<p @click="buttonEvaluation(item.id)" class="button-evaluation"  v-if="item.orderstatus =='2'&& item.cpstatus == '0'">继续检测</p>
						</div>
					</div>
					<ul>
						<li><b>订单日期 : </b><span>{{item.createtime}}</span></li>
						<li><b>订单号 : </b><span>{{item.ordernumber}}</span></li>
						<li><b>检测状态 : </b><span v-if = "item.cpstatus  == '0' ">未检测</span><span v-if = "item.cpstatus  >'0' ">已检测</span></li>
						<li v-if = 'item.orderstatus == 2 || item.orderstatus == 4'><b>支付方式 : </b><span v-if = "item.payType  == 1  ">支付宝</span><span v-if = "item.payType  =='2' ">微信</span> <span v-if = "item.payType  =='3' ">电子卡</span></li>
						<li v-if = 'item.orderstatus == 2 && (item.payType  ==1 || item.payType  ==2)'><b>实际支付价格 : </b><em>￥{{item.tcprice}}</em></li>
						<li v-if = 'item.orderstatus == 1'><b>需付款: </b><em>￥{{item.tcprice}}</em></li>
						<li v-if = 'item.orderstatus == 3'><b>需付款: </b><em>￥{{item.tcprice}}</em></li>
						<li v-if = 'item.orderstatus == 4'><b>需付款: </b><em>￥{{item.tcprice}}</em></li>
						<li v-if = 'item.orderstatus == 2 && item.payType  ==3 '><b>实际支付价格: </b><em>￥0.00</em></li>
					</ul>
				</div>
				<div class="block">
					<span class="el-pagination__total">共 <span>{{getPages}}</span> 页</span>
					<el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :total="getTotal" layout="prev, pager, next, jumper">
					</el-pagination>
					<el-button size="mini">确定</el-button>
				</div>
			</div>
		</div>
		<div id="myfroms"></div>
	</div>	
</template>
<script>
import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components: components,
		data() {
			return {
				isShowNull: false,
				isShowOrderList:false,
				getOrserList: {},
				getPages: null,
			    getTotal: null,
			    pageSize: null,
			    stateButton: '',
			    getordernumber:'',
			}
		},//data
		created() {
			this.$http.post(urls.urltest + "/personal/getOrderList.json",{
				token: localStorage.getItem('token')
			}).then(function(res){
				console.log(res.body)
				if(res.body.records.length){
					this.isShowOrderList = true;
					this.isShowNull = false;
					console.log(res.body)
					this.getOrserList = res.body.records;
				    this.getPages = res.body.pages;
				    this.getTotal = res.body.total;
				    this.pageSize = res.body.size;
				}else{
					this.isShowOrderList = false;
					this.isShowNull = true;
				}
			})
		},
		methods:{
			handleCurrentChange(val) {
					this.$http.post(urls.urltest + '/personal/getOrderList.json', {
						token: localStorage.getItem('token'),
						current: val,
					}).then(function(res) {
						this.getOrserList = res.body.records
					});
				},
		    buttonCancel(TC) {
		    	if(TC == '青年版-基础套餐'){
		    		this.$router.replace('/payment?pID=1');
		    	}else if(TC == '中年版-基础套餐'){
		    		this.$router.replace('/payment?pID=2');
		    	}else if(TC == '老年版-基础套餐'){
		    		this.$router.replace('/payment?pID=3');
		    	}else {
		    		this.$router.replace('/payment?pID=1');
		    	}
		    },
		    buttonOrder(orderNumber,reportEid) {
		    		localStorage.setItem('orderNumber',orderNumber)
		    		localStorage.setItem('eid',reportEid)
		    		this.$router.replace('/payQuest')
		    },
		    buttonEvaluation (reportEid) {
		    	this.$http.post(urls.urltest + "/personal/checkUser.json",{
						token:localStorage.getItem('token'),
						phone:localStorage.getItem('phone')
					}).then(function(res){
						localStorage.setItem('eid',reportEid)
						if(res.body == '0'){
							 this.$router.push('/startTest')
							}else{
							this.$router.push('/gamelist')
						}
					})
		    },
		    buttonLook (reportEid,childReportPID,reportBid) {
		    	localStorage.setItem('eid',reportEid)
		    	if(childReportPID == 6 && reportBid == 2){
						window.open('/#/mechanismCard')
				}else if(childReportPID == 1 && reportBid == 1){
						window.open('/#/mechanismPrin')
				}else{
						window.open('/#/reportpage')
				}
		    }
		}
	}

</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.ordermanagement-wrap{
		width: 100%;
		height: 100%;
		@include flexbox;
		@include flex-direction(column);
		.ordermanagement{
			@include flex;
			width: 100%;
			height: 100%;
			overflow-y: auto;
			position: relative;
			.ordermanagement-null{
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				p{
					text-align: center;
					line-height: .7rem;
					font-size: .14rem;
					color: #666666;
					font-weight: bold;
				}
			}
			.ordermanagement-list{
				margin: 0 auto;
				width: 12rem;
				.list-content{
					background: #fff;
					box-shadow: 0 0 3px #C3C3C3;
					margin-bottom: .35rem;
	
					.div{
						border-bottom: 1px dashed #979797;
						margin: 0 .4rem;
						padding: .45rem 0;
						@include flexbox;
						justify-content: space-between;
						h4{
							font-size: .18rem;
							color: #555555;
							font-weight: normal;
							span{
							}
						}
						div{
							@include flexbox;
							align-items: center;
							em{
								font-size: .14rem;
								padding-right: .85rem;
								color: #555;
								display: block;
								float: left;
							}
							p{
								font-size: .14rem;
								width: 1.2rem;
								height: .35rem;
								color: #fff;
								text-align: center;
								line-height: .35rem;
								display: inline-block;
								cursor: pointer;
								box-shadow: 0 2px 4px #c3c3c3;
								float: left;
							}
							.button-cancel{
								background: #01BCD4;
							}
							.button-noOrder{
								background: #FF912F;
							}
							.button-order{
								background: #01BCD4;
							}
							.button-evaluation{
								background: #01BCD4;
							}
							
						}
					}
					ul{
						@include flexbox;
						margin: 0 .4rem;
						padding: .29rem 0 .4rem 0;
						justify-content: space-between;
						li{
							font-size: .14rem;
							color: #555;
							font-family: PingFangTC-Semibold;
							em{
								color: red;
							}
						}
					}
				}
				.block{
					padding: 100px 0 91px 0;
					text-align: center;
					justify-content: center;
					display: flex;
					font-size: .14rem;
					.el-pagination__total {
						line-height: 32px;
						color: #48576a;
					}
					.el-pager li.active {
							border-color: #01BCD4;
							background-color: #01BCD4;
					  }
					 .el-icon-arrow-left {
			          display: inline-block!important;
		             }
			
					 .el-icon-arrow-right {
						display: inline-block!important
					}
					
					.el-pagination .btn-prev:after {
						content: '上一页';
					}
					.el-pagination .btn-next:before {
						content: '下一页';
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// ordermanagement.vue?ac1aa388